module.exports = __webpack_public_path__ + "static/media/04.4c3ea93d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-slideshow/04.jpg
// module id = 363
// module chunks = 0